import { routes } from '@linqpal/models'

interface InvoiceMetadata {
  acceptAchPayment: boolean
  bnplPaymentAvailable: boolean
  cardPaymentAvailable: boolean
  loanApplicationStatus?: string
  currentInvoiceCreditStatus: string
}
interface GetInvoiceParams {
  invoiceId?: string
  invoiceNumber?: string
  supplierCompanyId?: string
}

interface GetInvoiceResponse {
  invoice: any
  invoiceMetadata: InvoiceMetadata
}

export const getInvoice = async ({
  invoiceId,
  invoiceNumber,
  supplierCompanyId,
}: GetInvoiceParams): Promise<GetInvoiceResponse | null> => {
  try {
    const resp = await routes.invoices.show({
      id: invoiceId,
      invoiceNumber,
      supplierCompanyId,
    })
    if (!resp.invoices) return null
    const invoice = resp.invoices[0]

    const { invoices, ...flags } = resp
    const invoiceMetadata = {
      ...flags,
      loanApplicationStatus: flags.loanApplicationStatus || 'new',
    }

    return { invoice, invoiceMetadata }
  } catch (err) {
    console.error(err)
    return null
  }
}
